import React, { createContext, useContext, useState, useEffect } from 'react';

const ShipmentContext = createContext();

export const ShipmentProvider = ({ children }) => {
  const [shipmentData, setShipmentData] = useState(() => {
    const saved = localStorage.getItem('shipment_data');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error('Failed to parse shipment data', e);
        return null;
      }
    }
    return null;
  });

  // Функция для обновления данных
  const updateShipmentData = (data) => {
    setShipmentData(data);
    localStorage.setItem('shipment_data', JSON.stringify(data));
  };

  // Слушаем изменения из других вкладок
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'shipment_data') {
        const newData = e.newValue ? JSON.parse(e.newValue) : null;
        setShipmentData(newData);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <ShipmentContext.Provider value={{ shipmentData, updateShipmentData }}>
      {children}
    </ShipmentContext.Provider>
  );
};

export const useShipment = () => {
  const context = useContext(ShipmentContext);
  if (!context) {
    throw new Error('useShipment must be used within ShipmentProvider');
  }
  return context;
};